import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { GraduationCap, CheckCircle2, Play } from "lucide-react";
import { toast } from "sonner";

export default function MeLearning() {
  const [courses, setCourses] = useState([]);
  const [enrs, setEnrs] = useState([]);

  const load = async () => {
    const [c, e] = await Promise.all([
      api.get("/hr/courses"),
      api.get("/hr/enrollments/mine"),
    ]);
    setCourses(c.data); setEnrs(e.data);
  };
  useEffect(() => { load().catch(()=>{}); }, []);

  const enrolled = new Set(enrs.map(e => e.course_id));
  const completed = new Set(enrs.filter(e => e.status === "COMPLETED").map(e => e.course_id));

  const enroll = async (id) => {
    await api.post(`/hr/courses/${id}/enroll`);
    toast.success("Enrolled"); load();
  };
  const complete = async (enroll_id) => {
    await api.patch(`/hr/enrollments/${enroll_id}/complete`);
    toast.success("Course marked complete 🎓"); load();
  };

  return (
    <div className="space-y-4" data-testid="me-learning">
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500">Learning</div>
        <h1 className="text-3xl font-bold font-display mt-1 flex items-center gap-2"><GraduationCap className="w-7 h-7 text-pink" /> My learning path</h1>
        <p className="text-sm text-neutral-500 mt-1">{enrs.length} enrolled · {completed.size} completed</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map(c => {
          const isCompleted = completed.has(c.course_id);
          const isEnrolled = enrolled.has(c.course_id);
          const enr = enrs.find(e => e.course_id === c.course_id);
          return (
            <Card key={c.course_id} className="border-0 shadow-sm" data-testid={`me-course-${c.course_id}`}>
              <CardContent className="p-5">
                <div className="flex items-start justify-between">
                  <Badge variant="outline" className="text-[9px]">{c.category}</Badge>
                  {isCompleted && <Badge className="bg-teal text-white text-[9px] border-0"><CheckCircle2 className="w-3 h-3 mr-0.5" /> Done</Badge>}
                </div>
                <h3 className="font-semibold mt-2">{c.title}</h3>
                <p className="text-xs text-neutral-500 mt-1">{c.description}</p>
                <div className="text-[11px] text-neutral-500 mt-2">{c.duration_min} min · {c.provider}</div>
                <div className="mt-3">
                  {isCompleted ? (
                    <Button size="sm" variant="outline" disabled className="w-full">Completed</Button>
                  ) : isEnrolled ? (
                    <Button size="sm" className="btn-primary w-full" onClick={()=>complete(enr.enroll_id)} data-testid={`me-course-complete-${c.course_id}`}>
                      <CheckCircle2 className="w-3.5 h-3.5 mr-1" /> Mark complete
                    </Button>
                  ) : (
                    <Button size="sm" className="w-full" onClick={()=>enroll(c.course_id)} data-testid={`me-course-enroll-${c.course_id}`}>
                      <Play className="w-3.5 h-3.5 mr-1" /> Enroll
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
